(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["draggable-slider"] && !Shopify.designMode) return;
  try {
    
const knob = document.querySelector('.slider-knob');
const track = document.querySelector('.slider-track');
const images = document.querySelectorAll('.image-container img');
let isDragging = false;

function onDragStart(event) {
    isDragging = true;
    event.preventDefault();
}

function onDragMove(event) {
    if (isDragging) {
        let clientX = event.touches ? event.touches[0].clientX : event.clientX;
        let trackRect = track.getBoundingClientRect();
        let newLeft = clientX - trackRect.left - knob.offsetWidth / 2;
        newLeft = Math.max(0, Math.min(newLeft, trackRect.width - knob.offsetWidth));
        knob.style.left = newLeft + 'px';
        let percentage = newLeft / (trackRect.width - knob.offsetWidth);
        let index = Math.min(images.length - 1, Math.floor(percentage * images.length));
        updateImages(index);
    }
}

function onDragEnd() {
    isDragging = false;
}

knob.addEventListener('mousedown', onDragStart);
document.addEventListener('mousemove', onDragMove);
document.addEventListener('mouseup', onDragEnd);

// Touch events for mobile
knob.addEventListener('touchstart', onDragStart);
document.addEventListener('touchmove', onDragMove);
document.addEventListener('touchend', onDragEnd);

function updateImages(index) {
    images.forEach((img, i) => {
        img.classList.toggle('active', i === index);
    });
}


  } catch(e) { console.error(e); }
})();
})();
